const {
  GET_TASK_PRESCRIBERS_LIST_SUCCESS,
  GET_TASK_PRESCRIBERS_LIST_FAIL,
  GET_PRESCRIBERS_LIST_SUCCESS,
  GET_PRESCRIBERS_LIST_FAIL,
  ADD_PRESCRIBER_SUCCESS,
  ADD_PRESCRIBER_FAIL,
  UPDATE_PRESCRIBER_SUCCESS,
  UPDATE_PRESCRIBER_FAIL,
  DELETE_PRESCRIBER_SUCCESS,
  DELETE_PRESCRIBER_FAIL,
} = require("./actionType");

const INITSTATE = {
  list: [],
  res: [],
  error: [],
};

const Prescriber = (state = INITSTATE, action) => {
  switch (action.type) {
    case DELETE_PRESCRIBER_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case DELETE_PRESCRIBER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_PRESCRIBER_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case UPDATE_PRESCRIBER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_PRESCRIBER_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case ADD_PRESCRIBER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_PRESCRIBERS_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload,
      };
    case GET_PRESCRIBERS_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_TASK_PRESCRIBERS_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload,
      };
    case GET_TASK_PRESCRIBERS_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default Prescriber;
